jQuery(document).ready(function ($) {

    $(".bloc_carte").each(function () {

        var $bloc = $(this);
        var $carte = $bloc.find(".carte");
        var $points = $bloc.find(".point");
        var $sidebar = $bloc.find(".carte-sidebar");
        var $items = $bloc.find(".carte-sidebar-item");

        // animation d'entrée
        // sous 1024px la carte occupe toute la largeur : le zoom x1.5 la ferait
        // déborder et créerait un scroll horizontal, on garde un simple fondu
        var mm = gsap.matchMedia();

        mm.add("(min-width: 1024px)", function () {
            gsap.from($carte, {
                opacity: 0,
                scale: 1.5,
                y: +100,
                scrollTrigger: {
                    trigger: $carte,
                    start: 'top 100%',
                    end: 'top 50%',
                    scrub: 1,
                    markers: false
                }
            });
        });

        mm.add("(max-width: 1023.98px)", function () {
            gsap.from($carte, {
                opacity: 0,
                y: +50,
                scrollTrigger: {
                    trigger: $carte,
                    start: 'top 100%',
                    end: 'top 60%',
                    scrub: 1,
                    markers: false
                }
            });
        });

        // quitter un point : reset
        $points.on('mouseleave', function () {
            $points.removeClass('active');
            $items.removeClass('dimmed active');
        });

        // hover sur un point de la carte (click : équivalent au tap)
        $points.on('mouseenter click', function () {
            var idx = $(this).data('point');
            var $target = $items.filter('[data-point="' + idx + '"]');

            // activer le point
            $points.removeClass('active');
            $(this).addClass('active');

            // sidebar : dimmer les autres, activer la cible
            $items.addClass('dimmed').removeClass('active');
            $target.removeClass('dimmed').addClass('active');

            // scroller la sidebar vers la tuile
            if ($target.length && $sidebar.length) {
                $sidebar.stop().animate({
                    scrollTop: $sidebar.scrollTop() + $target.position().top - $sidebar.position().top
                }, 400);
            }
        });

        // hover sur une tuile de la sidebar (click : équivalent au tap)
        $items.on('mouseenter click', function () {
            var idx = $(this).data('point');
            var $targetPoint = $points.filter('[data-point="' + idx + '"]');

            // activer le point correspondant
            $points.removeClass('active');
            $targetPoint.addClass('active');

            // sidebar : dimmer les autres
            $items.addClass('dimmed').removeClass('active');
            $(this).removeClass('dimmed').addClass('active');
        });

        // quitter la zone carte+sidebar : tout reset
        $bloc.find('.carteContainer').on('mouseleave', function () {
            $points.removeClass('active');
            $items.removeClass('dimmed active');
        });

    });

});
